import { Metadata } from 'next';

import { LocaleKey, defaultLocaleKey, localeKeys } from '@/constants/locales';

export const getLocaleFromPathname = (pathname: string) =>
  localeKeys.find((locale) => pathname.startsWith(`/${locale}/`) || pathname === `/${locale}`);

export const getLocaleSpecificUrl = (localeKey: LocaleKey, pathname: string) => {
  const isDefaultLocaleKey = localeKey === defaultLocaleKey;
  if (pathname === '/') {
    return isDefaultLocaleKey ? '/' : `/${localeKey}`;
  }
  for (const key of localeKeys) {
    if (pathname === `/${key}`) {
      return isDefaultLocaleKey ? '/' : `/${localeKey}`;
    }
    if (pathname.startsWith(`/${key}/`)) {
      return pathname.replace(`/${key}`, isDefaultLocaleKey ? '' : `/${localeKey}`);
    }
  }
  return isDefaultLocaleKey ? pathname : `/${localeKey}${pathname}`;
};

export const getMetaLanguages = (
  currentLocale: LocaleKey,
  basePath: string,
  pathname: string,
): Metadata['alternates'] => {
  const languages: Record<string, string> = {};
  const canonicalPathname = getLocaleSpecificUrl(currentLocale, pathname);

  localeKeys.forEach((k) => {
    const languagePathname = getLocaleSpecificUrl(k, pathname);
    languages[localeToLanguageMapper(k)] = languagePathname === '/' ? basePath : `${basePath}${languagePathname}`;
  });
  return {
    canonical: `${basePath}${canonicalPathname === '/' ? '' : canonicalPathname}`,
    languages,
  };
};

// ISO-639-1
export const localeToLanguageMapper = (localeKey: LocaleKey) => {
  if (localeKey === 'ua') {
    return 'uk';
  }
  return localeKey;
};
